var $ = jQuery;
var isChangeDirectionListenerActive = true;
const focusableSelector = `
  a[href]:not([tabindex='-1']), 
  area[href]:not([tabindex='-1']), 
  input:not([type='hidden']):not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  select:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  textarea:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  button:not([disabled]):not([aria-hidden='true']):not([tabindex='-1']), 
  iframe:not([tabindex='-1']), 
  object:not([tabindex='-1']), 
  embed:not([tabindex='-1']), 
  [contenteditable]:not([tabindex='-1']), 
  [tabindex]:not([tabindex='-1'])`;

const A11YFix = {
	FixFooterToggle: function () {
		$('#footer .footer-menu ul > li .toggle-footer-link').each(function () {
			$(this).attr('aria-expanded', 'false');
			$(this).click(function (event) {
				event.preventDefault();
				$(this).parent().click();
				$(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'false');
			});
			$(this).keydown(function (event) {
				if (event.key == 'Enter') {
					$(this).click();
				}
			});
		});
	},
	FixAnnon: function () {
		$('.section-slideshow .swiper-prev, .section-slideshow .swiper-next').each(
			function () {
				var that = this;
				$(this).click(function () {
					setTimeout(function () {
						$(that)
							.closest('.section-slideshow')
							.find('.swiper-slide-visible')
							.last()
							.find('a')
							.first()
							.focus();
					}, 500);
				});
			},
		);
		$(document).on(
			'keydown.a11y2',
			'#yotpo-widget-btn, #yotpo-main-widget-btn',
			function (event) {
				if (event.key == 'Enter') {
					$(this).click();
					event.preventDefault();
				}
			},
		);
	},
	FixMainMenu: function () {
		const descriptionId = 'menu-description-a11y';
		$('body').append(
			'<p class="sr-only" id="' +
				descriptionId +
				'">Use Alt + Down arrow key to expand, escape to collapse, enter/space to activate the link</p>',
		);
		$('#mainMenu-rewards').keydown(function (event) {
			if (event.key == 'ArrowLeft') {
				$(this)
					.closest('li.nav__item')
					.prev()
					.find('> div > .nav_item__link')
					.focus();
				event.preventDefault();
			}
		});
		$('.header__nav > ul > li.transport-recipient').each(function () {
			$(this)
				.find('.nav_item__wrap > a.nav_item__link')
				.each(function () {
					$(this).attr('aria-expanded', 'false');
					$(this).attr('aria-describedby', descriptionId);
					$(this).keydown(function (event) {
						if (event.key == 'ArrowDown') {
							$(this).closest('li.nav__item.group').addClass('open-menu');
							$(this).attr('aria-expanded', true);
							event.preventDefault();
						} else if (event.key == 'ArrowUp' || event.key == 'Escape') {
							$(this).closest('li.nav__item').removeClass('open-menu');
							$(this).attr('aria-expanded', false);
							event.preventDefault();
						} else if (event.key == 'ArrowRight') {
							$(this)
								.closest('li.nav__item')
								.next()
								.find('> div > .nav_item__link')
								.focus();
							event.preventDefault();
						} else if (event.key == 'ArrowLeft') {
							$(this)
								.closest('li.nav__item')
								.prev()
								.find('> div > .nav_item__link')
								.focus();
							event.preventDefault();
						}
					});
				});
			$(this)
				.find('.mega-menu a')
				.each(function () {
					$(this).keydown(function (event) {
						if (event.key == 'ArrowUp' || event.key == 'Escape') {
							$(this).closest('li.nav__item.group').removeClass('open-menu');
							const mainElem = $(this)
								.closest('li.nav__item.group')
								.find('.nav_item__wrap > a.nav_item__link');
							mainElem.attr('aria-expanded', false);
							mainElem.focus();
							event.preventDefault();
						}
					});
				});
		});
	},
	FixSliders: function () {
		$('#swiperVideoPlay').click(function () {
			let video = $(this)
				.closest('.a11y-container-class')
				.find('.swiper-slide-visible video')
				.get(0);
			if (video.paused) {
				video.play();
				$(this).attr('aria-pressed', false);
			} else {
				video.pause();
				$(this).attr('aria-pressed', true);
			}
		});
		$('.swiper-container:not(.story-nav-items .swiper-container)').each(
			function () {
				var that = this;
				$(this).parent().addClass('a11y-container-class');
				SwiperInstance = $(this)[0].swiper;
				if (
					$(that).find('.swiper-slide').length > 1 &&
					!$(that).parent().hasClass('yotpo-redemption-options-carousel')
				) {
					if ($(that).find('.swiper-slide-visible').first().index() == 0) {
						$(that)
							.closest('.a11y-container-class')
							.find('.right-arrow-slider')
							.attr({ 'aria-disabled': 'false' });
						$(that)
							.closest('.a11y-container-class')
							.find('.left-arrow-slider')
							.attr({ 'aria-disabled': 'true' });
					} else if (
						$(that).find('.swiper-slide-visible').last().index() ==
						$(that).find('.swiper-slide').length - 1
					) {
						$(that)
							.closest('.a11y-container-class')
							.find('.right-arrow-slider')
							.attr({ 'aria-disabled': 'true' });
						$(that)
							.closest('.a11y-container-class')
							.find('.left-arrow-slider')
							.attr({ 'aria-disabled': 'false' });
					} else {
						$(that)
							.closest('.a11y-container-class')
							.find('.right-arrow-slider')
							.attr({ 'aria-disabled': 'false' });
						$(that)
							.closest('.a11y-container-class')
							.find('.left-arrow-slider')
							.attr({ 'aria-disabled': 'false' });
					}
					$(that)
						.closest('.a11y-container-class')
						.find('.swiper-slide:not(.swiper-slide-visible)')
						.find('a,button')
						.attr({ tabindex: '-1' });
					$(that)
						.closest('.a11y-container-class')
						.find('.swiper-slide-visible')
						.find('a,button')
						.attr({ tabindex: '0' });
					$(that)
						.closest('.a11y-container-class')
						.find('.swiper-slide:not(.swiper-slide-visible)')
						.attr({ tabindex: '-1', 'aria-hidden': 'true' });
					$(that)
						.closest('.a11y-container-class')
						.find('.swiper-slide-visible')
						.removeAttr('tabindex')
						.removeAttr('aria-hidden');

					if (SwiperInstance) {
						// SwiperInstance.autoplay.stop();
						// SwiperInstance.on('slideChange', function () {
						// console.log('slide changed');
						// });

						$('.swiper-wrapper').removeAttr('aria-live');
						SwiperInstance.on('slideChangeTransitionEnd', function () {
							$(
								'.product-gallery-thumbnails .a11y_enter_key[tabindex="0"]',
							).removeAttr('aria-current');
							$(
								'.product-gallery-thumbnails .active .a11y_enter_key[tabindex="0"]',
							).attr('aria-current', true);
							$(that)
								.closest('.a11y-container-class')
								.find('.swiper-slide:not(.swiper-slide-visible)')
								.find('a,button')
								.attr({ tabindex: '-1' });
							$(that)
								.closest('.a11y-container-class')
								.find('.swiper-slide-visible')
								.find('a,button')
								.attr({ tabindex: '0' });
							$(that)
								.closest('.a11y-container-class')
								.find('.swiper-slide:not(.swiper-slide-visible)')
								.attr({ tabindex: '-1', 'aria-hidden': 'true' });
							$(that)
								.closest('.a11y-container-class')
								.find('.swiper-slide-visible')
								.removeAttr('tabindex')
								.removeAttr('aria-hidden');
							if ($(that).find('.swiper-slide-visible').first().index() == 0) {
								$(that)
									.closest('.a11y-container-class')
									.find('.right-arrow-slider')
									.attr({ 'aria-disabled': 'false' });
								$(that)
									.closest('.a11y-container-class')
									.find('.left-arrow-slider')
									.attr({ 'aria-disabled': 'true' });
							} else if (
								$(that).find('.swiper-slide-visible').last().index() ==
								$(that).find('.swiper-slide').length - 1
							) {
								$(that)
									.closest('.a11y-container-class')
									.find('.right-arrow-slider')
									.attr({ 'aria-disabled': 'true' });
								$(that)
									.closest('.a11y-container-class')
									.find('.left-arrow-slider')
									.attr({ 'aria-disabled': 'false' });
							} else {
								$(that)
									.closest('.a11y-container-class')
									.find('.right-arrow-slider')
									.attr({ 'aria-disabled': 'false' });
								$(that)
									.closest('.a11y-container-class')
									.find('.left-arrow-slider')
									.attr({ 'aria-disabled': 'false' });
							}
						});
					}
				}
			},
		);
	},
	FixCart: function () {
		// $("body").on("focus", "#cart-end", function (event) {
		//   console.log("cart-end");
		//   event.preventDefault();
		//   $(this).parent().find(".a11y_cart_close").focus();
		// });
	},
	FixHotspots: function () {
		$(document).on('focus', '.a11y-hotspot-handle', function () {
			$(this).find('.a11y-hotspot-tooltip').addClass('opacity-100');
		});
		$(document).on('blur', '.a11y-hotspot-handle', function () {
			$('.a11y-hotspot-tooltip').removeClass('opacity-100');
		});
	},
};

function focusClose(elem) {
	setTimeout(function () {
		$(this).parent().find('.a11y_cart_close').focus();
	}, 250);
}

function trapFocus(element) {
	var focusableEls = element.querySelectorAll(
			'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), input[type="submit"]:not([disabled]), input[type="email"]:not([disabled]), select:not([disabled])',
		),
		firstFocusableEl = focusableEls[0],
		lastFocusableEl = focusableEls[focusableEls.length - 1],
		KEYCODE_TAB = 9;

	firstFocusableEl.focus(); // Focus to first focusable element in the modal

	element.addEventListener('keydown.a11ytab', function (e) {
		var isTabPressed = e.key === 'Tab' || e.keyCode === KEYCODE_TAB;

		if (!isTabPressed) {
			return;
		}

		if (e.shiftKey) {
			/* shift + tab */ if (document.activeElement === firstFocusableEl) {
				lastFocusableEl.focus();
				e.preventDefault();
			}
		} /* tab */ else {
			if (document.activeElement === lastFocusableEl) {
				firstFocusableEl.focus();
				e.preventDefault();
			}
		}
	});
}

var KeepChecking = function (selector, call) {
	let timer;
	let isObserving = false;
	$('body').each((i, body) => {
		const observer = new MutationObserver((mutations) => {
			const elem = $(selector);
			if (elem.length) {
				clearTimeout(timer);
				isObserving = true;
				timer = setTimeout(() => {
					if (isObserving) {
						call();
						isObserving = false;
					}
				}, 100);
			} else {
				isObserving = false;
			}
		});
		observer.observe(body, {
			attributes: true,
			childList: true,
			subtree: true,
		});
	});
};
$('.product-essentials--buy-box a.active').attr('aria-current', 'true');

$(document).ready(function () {
	$(document).on('keydown.a11yescape', function (event) {
		document.body.classList.remove('mouse-only');
		if (event.key == 'Escape') {
			document.body.classList.add('keyboard-escape');
		} else {
			document.body.classList.remove('keyboard-escape');
			if (event.key == 'Enter' && $(event.target).hasClass('a11y_enter_key')) {
				$(event.target).click();
			}
		}
	});

	$(document).on('mousemove', function (event) {
		document.body.classList.add('mouse-only');
		document.body.classList.remove('keyboard-escape');
	});

	// KeepChecking('.CampaignType--popup', function () {
	//   var Campaign = document.getElementByClass('CampaignType--popup');
	//   trapFocus(Campaign);
	// });

	KeepChecking('#storyViewer', function () {
		var storyview = document.getElementById('storyViewer');
		$('.yotpo-bottomline.pull-left.star-clickable').removeAttr('tabindex');
	});

	$('#shopify-section-header').attr('role', 'banner');
	$('img:not([alt]), img[alt=" "]').attr('alt', '');

	$('.cart__item_details div button').click(function (e) {
		setTimeout(function () {
			$(e.target).focus();
		}, 1000);
	});

	setTimeout(function () {
		$('.a11y_rem_role a').removeAttr('role');
		$('.a11y_rem_role a').removeAttr('aria-label');

		// $('.a11y_rem_role a').each(function(){
		// var items =  $(this).attr('aria-label');
		// var linktext = $(this).text().trim();
		// $(this).attr('aria-label', linktext +' '+items);
		// });

		// $(".section-slideshow").each(function () {
		//   var title = $(this).find("aside .font-bold").text().trim();
		//   if (title.trim() != "") {
		//     $(this)
		//       .find(".swiper-prev.swiper-button-prev-unique")
		//       .attr("aria-label", "Previous slide of" + " " + title);
		//     $(this)
		//       .find(".swiper-next.swiper-button-next-unique")
		//       .attr("aria-label", "Next Slide of" + " " + title);
		//   }
		// });

		$('.section-slideshow aside h1').attr({
			role: 'heading',
			'aria-level': '2',
		});
	}, 1000);

	// $(".section-slideshow").each(function () {
	//   var title = $(this).find("aside .font-bold").text().trim();
	//   if (title.trim() != "") {
	//     $(this)
	//       .find(".swiper-prev.swiper-button-prev-unique")
	//       .attr("aria-label", "Previous slide of" + " " + title);
	//     $(this)
	//       .find(".swiper-next.swiper-button-next-unique")
	//       .attr("aria-label", "Next Slide of" + " " + title);
	//   }
	// });

	$('.mega__link_list .nav__list_item_parent').each(function () {
		$(this).find('svg, span.sr-only').attr('aria-hidden', 'true');
	});

	$('footer .list-none svg').attr('aria-hidden', 'true');

	$('.a11y_rem_btn a button').replaceWith(function () {
		return $("<div class='button' />").append($(this).contents());
	});

	$('.footer-company').each((i, wrap) => {
		$(wrap)
			.find('> ul:not(#social-icons)')
			.each((i, ul) => {
				$(ul).find('br').attr('aria-hidden', true);
				$(ul).attr('role', 'none');
				$(ul).find('> li').wrapAll('<ul></ul>');
			});
	});

	// $(".blog-menu").each((i, menu) => {
	//   $(menu)
	//     .find("details")
	//     .each((i, details) => {
	//       function handleChange() {
	//         $(details)
	//           .find(".blog-nav-item > div[aria-expanded]")
	//           .attr({
	//             tabindex: 0,
	//             role: "button",
	//             "aria-expanded": details.hasAttribute("open"),
	//           });
	//       }

	//       handleChange();

	//       const observer = new MutationObserver(() => {
	//         handleChange();
	//       });

	//       observer.observe(details, {
	//         attributes: true,
	//       });
	//     });
	// });

	$('.collection-filters').each((i, filters) => {
		$(filters)
			.find('details')
			.each((i, details) => {
				$(details)
					.find('ul[aria-controlledby]')
					.removeAttr('aria-controlledby');
			});
	});

	$('#privacy-policy-registration-information-sunny-health').each((i, page) => {
		$(page)
			.find('ul > ul')
			.each((i, ul) => {
				$(ul).wrap('<li></li>');
			});
	});

	var i = 1;
	$('iframe[src*="https://www.facebook.com"]').each(function () {
		$(this).attr('title', 'Facebook post ' + i);
		i++;
	});
	var j = 1;
	$('iframe[src*="https://www.instagram.com"]').each(function () {
		$(this).attr('title', 'Instagram post ' + j);
		j++;
	});
	var k = 1;
	$('iframe[src*="https://www.youtube.com"]').each(function () {
		$(this).attr('title', 'Youtube post ' + k);
		k++;
	});

	$('.a11y_expandable').attr('aria-expanded', 'false');
	$('details[open] summary.a11y_expandable').attr({
		'aria-expanded': 'true',
		tabindex: 0,
	});

	$('.a11y_expandable').click(function () {
		$(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'false');
	});

	$('.header__nav .mega-menu').removeAttr('tabindex');
	$(
		'.product-essentials--buy-box .product-essentials--.font-bold svg, .product-essentials--.font-bold span.sr-only',
	).attr('aria-hidden', 'true');

	$('.swiper-wrapper.items-baseline .swiper-slide').each(function () {
		var size = $(this).find('.text-yellow-300 svg').length;
		$(this)
			.find('.text-yellow-300')
			.after(`<span class="sr-only">${size} star ratings</span>`);
		$(this).find('.text-yellow-300').attr('aria-hidden', 'true');
	});

	$('.shopify-section.accordion h2').attr({
		role: 'heading',
		'aria-level': '3',
	});
	$(
		'#faq-sunny-health-amp-fitness-create-the-ultimate-home-gym .shopify-section.accordion h2, #installment-payments-and-financing-options .shopify-section.accordion h2',
	).removeAttr('role');
	$(
		'#faq-sunny-health-amp-fitness-create-the-ultimate-home-gym .shopify-section.accordion h2, #installment-payments-and-financing-options .shopify-section.accordion h2',
	).removeAttr('aria-level');

	$(
		'table.a11y_remove, table.a11y_remove tr, table.a11y_remove td, table.a11y_remove tbody, table.a11y_remove th',
	).attr('role', 'none');
	$('table.a11y_remove th strong').attr({ role: 'heading', 'aria-level': '2' });
	$('.a11y_h2_h3').attr({ role: 'heading', 'aria-level': '3' });

	$(
		'#troubleshooting-guides-equipment-sunny-health-amp-fitness table.a11y_remove th',
	).each(function () {
		var strongElement = $(this).find('strong');
		var newPElement = $("<p role='heading' aria-level='4'>").text(
			strongElement.text(),
		);
		strongElement.replaceWith(newPElement);
	});

	$(
		'#troubleshooting-guides-equipment-sunny-health-amp-fitness strong.hide-mobile',
	).attr({ role: 'heading', 'aria-level': '3' });

	$('#Search-header').keydown(function (event) {
		if (event.which == '13') {
			event.target.click();
			setTimeout(function () {
				$('#modalSearchInput').focus();
			}, 250);
			event.preventDefault();
		}
	});

	$('div.mega-menu').each(function () {
		$(this).removeAttr('tabindex');
	});

	var tabs = $('.a11y_tabs li[role="tab"]');

	// Set initial tab as active
	tabs
		.first()
		.attr({
			tabindex: '0',
			'aria-selected': 'true',
		})
		.addClass('active');

	tabs.on('keydown', function (e) {
		var currentIndex = tabs.index(this);

		if (e.which === 39) {
			// Right arrow key
			currentIndex = (currentIndex + 1) % tabs.length;
		} else if (e.which === 37) {
			// Left arrow key
			currentIndex = (currentIndex - 1 + tabs.length) % tabs.length;
		} else if (e.which === 13) {
			// Enter key
			$(this).click();
			var target = $(this).data('target');
			tabs
				.attr({
					tabindex: '-1',
					'aria-selected': 'false',
				})
				.removeClass('active');
			$(this)
				.attr({
					tabindex: '0',
					'aria-selected': 'true',
				})
				.addClass('active');
			$(target).addClass('active');
		}

		tabs
			.attr({
				tabindex: '-1',
			})
			.removeClass('active');
		tabs
			.eq(currentIndex)
			.attr({
				tabindex: '0',
			})
			.addClass('active');
		tabs.eq(currentIndex).focus();
	});

	tabs.on('click', function () {
		var target = $(this).data('target');
		tabs
			.attr({
				tabindex: '-1',
				'aria-selected': 'false',
			})
			.removeClass('active');
		$(this)
			.attr({
				tabindex: '0',
				'aria-selected': 'true',
			})
			.addClass('active');
		$(target).addClass('active');
	});

	$('.a11y_click').keydown(function (event) {
		if (event.which == '13') {
			$(this).click();
		}
	});

	$('.a11y_cart').click(function () {
		setTimeout(function () {
			$('[data-modal="cart"] .cart__title').focus();
		}, 250);
	});

 //      setTimeout(function () {
 //  	$('.a11y_cart_close').click(function () {
 //        document.querySelector("html").removeAttribute('data-active-modal')
 //      // document.querySelector("#shopify-section-cart-modal > div").classList.remove('active')
	// });
	// 	}, 20);

	$('.sunny__cart-item').each((i, button) => {
		function handleChange() {
			const count = $(button).find('.cart-bubble');
			$(button).attr('aria-label', `${count.text().trim()} items in cart`);
		}

		handleChange();

		const observer = new MutationObserver(() => {
			handleChange();
		});

		observer.observe(button, {
			childList: true,
			subtree: true,
		});
	});

 //    $('.a11y_cart_close').on('click', function () {
 //      console.log(11111111111)
	// });
	// $('.a11y_cart_close').click(function () {
	// 	// $('.a11y_cart').focus();
 //      document.querySelector("html").removeAttribute('data-active-modal')
 //      document.querySelector("#shopify-section-cart-modal > div").classList.remove('active')
	// });

	$('.shopify-section-inspiration-gallery-grid .alt_null').attr('alt', '');

	$('#sitemap main ul').each(function () {
		var firstitem = $(this).find('li:first-child').html();
		$(this).before(firstitem);
	});

	$('#sitemap main ul li:first-child').remove();

	$('.miami-row-2 P').each(function () {
		var text = $(this).text().trim();
		$(this).attr('aria-hidden', 'true');
		$(this).before(`<h2 class="sr-only">${text}</h2>`);
	});

	$('.productitem--extra .yotpo-reviews-star-ratings-widget').removeAttr(
		'role',
	);

	$('.productitem--extra .yotpo-reviews-star-ratings-widget').removeAttr(
		'tabindex',
	);

	// $('#shopify-section-header').each((i, header) => {
	// const copyright = $(header).find('.section-header');
	// const form = $(`
	// 	<form class="color-scheme-form" id="desktop_view">
	// 		<label for="color-scheme-switcher">Color Scheme</label>
	// 		<select class="color-scheme-switcher" id="color-scheme-switcher">
	// 			<option value="default">Default</option>
	// 			<option value="accessible">Accessible</option>
	// 		</select>
	// 	</form>
	// `);

	const selectedValue = localStorage.getItem('color-scheme');
	const select = $('#color-scheme-switcher');

	select.on('change', (e) => {
		$(':root').attr({
			'data-color-scheme': e.target.value,
		});
		localStorage.setItem('color-scheme', e.target.value);
	});

	if (selectedValue) {
		$(':root').attr({
			'data-color-scheme': selectedValue || value,
		});

		select.val(selectedValue);
	}

	// copyright.prepend(form);
	// });

	// if ($(window).width() <= 1024) {
	// $('.modals--initialized .header__nav').each((i, header) => {
	// 	const copyright = $(header).find('.modal-search-form');
	// 	const form = $(`
	// 			<form id="color-scheme-mobile" class="color-scheme-form">
	// 				<label for="color-scheme-switcher">Color Scheme</label>
	// 				<select class="color-scheme-switcher" id="color-scheme-switcher">
	// 					<option value="default">Default</option>
	// 					<option value="accessible">Accessible</option>
	// 				</select>
	// 			</form>
	// 		`);

	// 	const selectedValue = localStorage.getItem('color-scheme');
	// 	const select = form.find('#color-scheme-switcher');

	// 	select.on('change', (e) => {
	// 		$(':root').attr({
	// 			'data-color-scheme': e.target.value,
	// 		});

	// 		localStorage.setItem('color-scheme', e.target.value);
	// 	});

	// 	if (selectedValue) {
	// 		$(':root').attr({
	// 			'data-color-scheme': selectedValue || value,
	// 		});

	// 		select.val(selectedValue);
	// 	}
	// 	if ($('#color-scheme-mobile').length == 0) {
	// 		form.insertBefore(copyright);
	// 	}
	// });
	// }

	A11YFix.FixFooterToggle();
	A11YFix.FixMainMenu();

	$('.filter-btn-a11y').click(function () {
		$('.filters__mobile_close').focus();
	});

	// $('#modalcollectionFiltersModalEnd').focus(function () {
	// 	$('.filters__mobile_close').focus();
	// });

	// $('#collectionFiltersModalStart').focus(function () {
	// 	$('#modalcollectionFiltersModalEnd').focus();
	// });

	$('#collectionFiltersModalStart').attr({
		tabindex: -1,
	});

	$('#mainMenu-account-button').click(function () {
		$(this).attr('aria-expanded', function (_, attr) {
			return attr == 'false';
		});
		$(this).siblings().toggleClass('show-menu');
	});

	$(
		'#mainMenu-account-button + .overlay + .mega-menu .nav__list-column-wrap > ul > li',
	).each(function () {
		$(this)
			.find('> a')
			.keydown(function (event) {
				if (event.key == 'Escape') {
					event.preventDefault();
					$('#mainMenu-account-button').click();
					$('#mainMenu-account-button').focus();
				}
			});
	});

	// $('.blog-nav').each((i, nav) => {
	// 	const button = $(nav).find('.blog-menu-button');

	// 	function handleChange() {
	// 		if (nav.classList.contains('active')) {
	// 			$(nav).parents().siblings().attr('aria-hidden', true);
	// 		} else {
	// 			$(nav).parents().siblings().removeAttr('aria-hidden');
	// 		}
	// 	}

	// 	button.on('click', () => {
	// 		setTimeout(() => {
	// 			handleChange();
	// 		}, 500);
	// 	});
	// });

	$('.header__nav').each((i, nav) => {
		const button = $('#navTrigger');

		function handleChange() {
			if (nav.classList.contains('active')) {
				$(nav).parents().siblings().attr('aria-hidden', true);
				$(nav)
					.siblings()
					.not(
						'.header__nav_mobile-close, .header__nav_logo, .header__nav_trigger, .nav__tools',
					)
					.attr('aria-hidden', true);
			} else {
				$(nav).parents().siblings().removeAttr('aria-hidden');
				$(nav).siblings().removeAttr('aria-hidden');
			}
		}

		button.on('click', () => {
			setTimeout(() => {
				handleChange();
			}, 500);
		});
	});

	$('.sunny__collections-grid-toggle').each((i, toggle) => {
		$(toggle).on('click', () => {
			setTimeout(() => {
				$(toggle)
					.find('span')
					.last()
					.text(
						$('.collection-products').hasClass('grid-cols-2') ? 'Grid' : 'List',
					);
				$(toggle).attr({
					'aria-label': $('.collection-products').hasClass('grid-cols-2')
						? 'Grid'
						: 'List',
				});
			}, 0);
		});
	});

	document.addEventListener('click', (event) => {
		if ($(event.target).closest('#mainMenu-account').length == 0) {
			$('.mega-menu, .overlay.mega-overlay').removeClass('show-menu');
			$('#mainMenu-account-button').attr('aria-expanded', 'false');
		}
	});

	console.log('ready!');
});

$(window).on('load', function () {
	$(
		'.story-nav-items-shop-by-category, .story-nav-items-shop-by-exercise, .story-nav-items-shop-by-goal',
	).each((i, slider) => {
		$(slider).find('li[role="group"]').removeAttr('role');
	});

	$('.accordion--section').each((i, section) => {
		$(section)
			.find('.accordion')
			.each((i, accordion) => {
				function handleChange() {
					$(accordion).find('.accordion-panel').removeAttr('aria-hidden');
				}

				handleChange();

				const observer = new MutationObserver((mutations) => {
					setTimeout(() => {
						handleChange();
					}, 100);
				});

				observer.observe(accordion, {
					attributes: true,
					attributeFilter: ['class'],
				});
			});
	});

	$('.yotpo-score-filter, .yotpo-media-filter').each((i, filter) => {
		function handleChange() {
			if (filter.hasAttribute('aria-expanded')) {
				$(filter).removeAttr('aria-expanded');
			}

			$('.yotpo-thumbnail[aria-selected]').removeAttr('aria-selected');
		}

		handleChange();

		const observer = new MutationObserver((mutations) => {
			setTimeout(() => {
				handleChange();
			}, 100);
		});

		observer.observe(filter, {
			attributes: true,
			attributeFilter: ['aria-expanded'],
		});
	});

	$('.yotpo-media-filter').each((i, filter) => {
		function handleChange() {
			$(filter)
				.find('.yotpo-media-select')
				.attr({
					'aria-checked': $(filter).attr('aria-checked'),
				});
			$(filter).find('.yotpo-media-select').removeAttr('readonly');

			setTimeout(() => {
				$(filter).removeAttr('role').removeAttr('tabindex');
			}, 100);
		}

		handleChange();

		const observer = new MutationObserver(() => {
			handleChange();
		});

		observer.observe(filter, {
			attributes: true,
			attributeFilter: ['aria-checked'],
		});
	});

	$('.yotpo-reviews-list').each((i, list) => {
		function handleChange() {
			$(list)
				.find('.yotpo-thumbnail')
				.removeAttr('aria-selected')
				.attr({
					'aria-label': function () {
						return $(this).attr('alt');
					},
				})
				.removeAttr('alt');
		}

		handleChange();

		const observer = new MutationObserver((mutations) => {
			handleChange();
		});

		observer.observe(list, {
			childList: true,
		});
	});

	$('.yotpo-reviews-main-widget, .yotpo-questions-and-answers').each(
		(i, widget) => {
			const observer = new MutationObserver((mutations) => {
				$(widget)
					.find('.yotpo-new-review-name input')
					.attr('autocomplete', 'name');
				$(widget)
					.find('.yotpo-new-review-email input')
					.attr('autocomplete', 'email');
			});

			observer.observe(widget, {
				childList: true,
			});
		},
	);

	// $('#swym-plugin').each((i, widget) => {
	// 	console.log(widget);
	// });

	$('.template-app-home, .template-page').each((i, page) => {
		$(page)
			.find('h1,h2,h3,h4,h5,h6')
			.each((i, heading) => {
				if (isDOMElementEmpty(heading)) {
					renameElementTag(heading, 'div');
				}
			});
	});

	$('.region-select').attr('aria-label', 'Select Region');

	$('.collection-products, .swiper-wrapper, .product-recommendations').each(
		(i, widget) => {
			function handlechange() {
				setTimeout(function () {
					$(widget)
						.find('.yotpo-sr-bottom-line-summary > div')
						.removeAttr('aria-label');
					$(widget)
						.find(
							'.yotpo-sr-bottom-line-summary div, .yotpo-sr-bottom-line-summary svg',
						)
						.removeAttr('aria-labelledby');
					$(widget)
						.find('.yotpo-sr-bottom-line-summary svg')
						.attr('aria-hidden', 'true');

					$(widget)
						.find('article')
						.each(function () {
							if (
								$(this).find(
									'.yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel > div .review-sr',
								).length <= 0
							) {
								$(this)
									.find(
										'.yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel > div',
									)
									.append('<span class="review-sr sr-only">Reviews</span>');
							}
						});
				}, 1000);
			}
			const observer = new MutationObserver((mutations) => {
				handlechange();
			});
			handlechange();

			observer.observe(widget, {
				childList: true,
			});
		},
	);

	$(
		'.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary > div',
	).removeAttr('aria-label');
	$(
		'.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary div, .yotpo-sr-bottom-line-summary svg',
	).removeAttr('aria-labelledby');
	$(
		'.yotpo-reviews-star-ratings-widget .yotpo-sr-bottom-line-summary svg',
	).attr('aria-hidden', 'true');

	$('.swiper-wrapper .swiper-slide.swiper-slide__card').each(function () {
		var link = $(this).find('.productitem--link');
		$(this)
			.find('.a11y_wish_link')
			.click(function () {
				window.open(link.attr('href'), '_self');
			});
	});
	// $('.swiper-wrapper').removeAttr('aria-live');

	$('.accordion .accordion-title').removeAttr('aria-disabled');
	$('.active button.accordion-title').attr('aria-expanded', 'true');

	$('nav.yotpo-reviews-pagination-container').attr('aria-label', 'Pagination');

	// $('.yotpo-horizontal-pagination').each(function () {
	// 	var parentDiv = $(this);
	// 	var ulElement = $('<ul></ul>');
	// 	// Wrap all the <a> elements inside the <ul>
	// 	parentDiv.find('a').wrapAll(ulElement);
	// 	// Wrap each <a> element inside a <li>
	// 	parentDiv.find('a').wrap('<li></li>');
	// });

	$('.yotpo-horizontal-pagination a').each(function () {
		var labelText = $(this).attr('aria-label');
		var modifiedText = labelText.replace(', Current Page', '');
		$(this).attr('aria-label', modifiedText);
	});

	$('.yotpo-sr-bottom-line-summary .star-container').attr(
		'aria-hidden',
		'true',
	);

	$(
		'.yotpo-sr-bottom-line-summary .yotpo-sr-bottom-line-right-panel .yotpo-sr-bottom-line-text',
	).append('<span class="sr-only">Reviews</span>');

	$('.icon-list article > span.items-center:first-child').attr(
		'aria-hidden',
		'true',
	);

	setTimeout(function () {
		$(
			'.yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon',
		).removeAttr('role');
		$(
			'.yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon',
		).removeAttr('aria-level');
		$(
			'.yotpo-step-icons.yotpo-reward-steps-icon div.yotpo-step-icon',
		).removeAttr('aria-label');
		$('.yotpo-email-container input, .klaviyo-form input').attr(
			'aria-required',
			'true',
		);

		$('.swym-wishlist-context-menu').attr('aria-expanded', 'false');
		$('.swym-wishlist-context-menu').click(function () {
			$(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'false');
		});

		$('.swym-empty-wishlist-title.swym-heading-1').attr({
			role: 'heading',
			'aria-level': '2',
		});
		$(
			'.yotpo-ask-question-btn-wrapper, .yotpo-new-review-btn-wrapper',
		).removeAttr('tabindex');

		$('.swym-wishlist-grid > div.swym-wishlist-item').each(function () {
			$(this).removeAttr('role');
			$(this).removeAttr('aria-label');
			$(this).removeAttr('tabindex');
			$(this)
				.find('.swym-product-final-price')
				.prepend('<span class="sr-only">Discounted Price</span>');
			$(this)
				.find('.swym-product-original-price')
				.prepend('<span class="sr-only">Regular Price</span>');
			var title = $(this).find('.swym-title-1').text().trim();
			var btn = $(this).find('.swym-add-to-cart-btn').text().trim();
			$(this)
				.find('.swym-add-to-cart-btn')
				.attr('aria-label', btn + ' ' + title);
		});
		$('.yotpo-main-reviews-widget #yotpo-main-widget-btn').click(function () {
			setTimeout(function () {
				$('.yotpo-review-form-modal .yotpo-modal-header').attr(
					'aria-level',
					'2',
				);
				$('.yotpo-review-form-modal #modalDescription h4').removeAttr('role');
				$('.yotpo-review-form-modal #modalDescription h4').removeAttr(
					'aria-level',
				);
				$(
					'.yotpo-review-form-modal #modalDescription h4, .yotpo-review-form-modal #modalDescription h6',
				).attr('role', 'none');
				var legend = $(
					'.yotpo-review-form-modal .yotpo-new-review-star-rating > legend',
				)
					.text()
					.trim();
				$(
					'.yotpo-review-form-modal .yotpo-new-review-star-rating > legend',
				).attr('role', 'none');
				$('.yotpo-review-form-modal .yotpo-new-review-star-rating').attr({
					role: 'group',
					'aria-label': legend,
				});
				$(
					'.yotpo-review-form-modal .yotpo-new-review-email .yotpo-new-input-container',
				).attr('aria-describedby', 'review-email');
				$(
					'.yotpo-review-form-modal .yotpo-new-review-email .yotpo-new-input-container+p',
				).attr('id', 'review-email');

				$(
					'.yotpo-review-form-modal .yotpo-file-upload .yotpo-upload-label',
				).attr('aria-describedby', 'a11y_upload');
				$(
					'.yotpo-review-form-modal .yotpo-file-upload .yotpo-upload-label+p',
				).attr('id', 'a11y_upload');

				// $('.yotpo-review-form-modal .yotpo-new-review-submit').click(function () {
				//   $('.yotpo-single-input-error').attr('role','alert');
				// })
			}, 250);
		});
		$(
			'.yotpo-screen-friends_emails .yotpo-tile-box form .yotpo-button-style',
		).click(function () {
			setTimeout(function () {
				$(
					'.yotpo-screen-friends_emails .yotpo-tile-box .yotpo-header-text',
				).removeAttr('tabindex');
			}, 500);
		});

		$('.yotpo-referral-widget-form input').removeAttr('aria-describedby');
		$('.yotpo-referral-widget-form').each(function () {
			let that = this;
			$(this)
				.find('.yotpo-button-style')
				.click(function () {
					var id = $(that)
						.find('.yotpo-referral-widget-error-message')
						.attr('id');
					$(that).find('input').attr('aria-describedby', id);
				});
		});
	}, 3000);

	$('.yotpo-background.yotpo-left-align-background img').attr('alt', '');
	$(
		'.standalone-bottomline .yotpo-bottomline.pull-left.star-clickable',
	).removeAttr('tabindex');

	$('.yotpo-star-ratings-clickable').each(function () {
		$(this).attr({ tabindex: '0', role: 'link' });
		$(this).keydown(function (event) {
			if (event.which == '13') {
				$(this).find('.yotpo-sr-bottom-line-summary').click();
				$('#a11y_rating_focus').focus();
			}
		});
	});

	$('.ugc-storefront-widgets-tabs-container.yotpo-main-widget-tabs').each(
		function () {
			$(this).attr('role', 'tablist');
			$(this)
				.find('div')
				.attr({ role: 'tab', 'aria-selected': 'false', tabindex: '-1' });
			$(this)
				.find('div.selected')
				.attr({ role: 'tab', 'aria-selected': 'true', tabindex: '0' });

			var tabs = $('.ugc-storefront-widgets-tabs-container__tab');
			tabs.on('keydown', function (e) {
				var currentIndex = tabs.index(this);
				switch (e.which) {
					case 39:
						currentIndex = (currentIndex + 1) % tabs.length;
						break;
					case 37:
						currentIndex = (currentIndex - 1 + tabs.length) % tabs.length;
						break;
					case 13:
						$(this).click();
						tabs
							.attr({ tabindex: '-1', 'aria-selected': 'false' })
							.removeClass('selected');
						$(this)
							.attr({ tabindex: '0', 'aria-selected': 'true' })
							.addClass('selected');

						return;
				}
				tabs.attr('tabindex', '-1').removeClass('selected');
				tabs
					.eq(currentIndex)
					.attr('tabindex', '0')
					.addClass('selected')
					.focus();
			});
		},
	);

	$('.yotpo-horizontal-pagination a').each(function () {
		var disable = $(this).hasClass('disabled');
		if (disable == true) {
			$(this).attr('tabindex', '-1');
		}
		$(this).click(function () {
			$('.yotpo-horizontal-pagination a').each(function () {
				var disable = $(this).hasClass('disabled');
				if (disable == true) {
					$(this).attr('tabindex', '-1');
				} else $(this).attr('tabindex', '0');
			});
		});
	});

	$('.yotpo-widget-products-redemption-container').each(function () {
		var title = $(this).find('.yotpo-headline').text().trim();

		$(this)
			.find('.yotpo-carousel-button-next, .yotpo-carousel-button-prev')
			.each((i, button) => {
				function handleChange() {
					if (button.classList.contains('yotpo-disable-arrow')) {
						$(button).attr({
							role: 'button',
							disabled: 'disabled',
						});

						$(button).removeAttr('tabindex');
					} else {
						$(button).attr({
							role: 'button',
							tabindex: 0,
						});

						$(button).removeAttr('disabled');
					}
				}

				handleChange();

				const observer = new MutationObserver((mutations) => {
					handleChange();
				});

				observer.observe(button, {
					attributes: true,
					attributeFilter: ['class'],
				});
			});

		$(this)
			.find('.yotpo-carousel-button-next')
			.attr({
				'aria-label': 'Next Slide of' + ' ' + title,
			});

		$(this)
			.find('.yotpo-carousel-button-prev')
			.attr({
				'aria-label': 'Previous Slide of' + ' ' + title,
			});

		$(this)
			.find('.yotpo-carousel-button-next, .yotpo-carousel-button-prev')
			.keydown(function (event) {
				if (event.which === 13) {
					$(this).click();
				}
			});
	});

	A11YFix.FixSliders();
	A11YFix.FixHotspots();

	$('.productitem--extra .yotpo-reviews-star-ratings-widget').removeAttr(
		'role',
	);
	$('.productitem--extra .yotpo-reviews-star-ratings-widget').removeAttr(
		'tabindex',
	);
	$('.a11y-container-class h2').attr({ role: 'heading', 'aria-level': '1' });

	const affirm = $('.affirm-as-low-as.text-xs');
	affirm.attr('aria-hidden', 'true');
	$('<p class="sr-only"></p>').text(affirm.text().trim()).insertAfter(affirm);
	A11YFix.FixAnnon();

	// $('video').each(function () {
	// 	if ($(this).parent().find('.sliderVideoPlayHandle')) {
	// 	}
	// });
	$(
		'.yotpo-redemption-options-carousel, .yotpo-redemption-options-carousel [role="listitem"',
	).removeAttr('role');

	$('.blog-menu-button').each(function () {
		$(this).attr('aria-expanded', 'false');
		console.log(window.outerWidth);
		if (window.outerWidth >= 1024) {
			$(this).parent().addClass('active');
		} else {
			$(this).parent().removeClass('active');
		}
		$(this).click(function () {
			$(this).attr('aria-expanded', function (index, attr) {
				return attr == 'false' ? true : false;
			});
			$(this).parent().toggleClass('active');
		});
	});

	$('.collection-filters').each((i, filters) => {
		$(filters)
			.find('#filterSets > details')
			.each((i, details) => {
				$(details).attr({
					role: 'group',
					'aria-label': `${$(details)
						.find('summary')
						.contents()
						.first()
						.text()
						.trim()}`,
				});

				$(details)
					.find('summary')
					.each((i, summary) => {
						function handleChange() {
							$(summary).attr({
								'aria-label': function () {
									return details.hasAttribute('open')
										? `${$(this).contents().first().text().trim()} expanded`
										: `${$(this).contents().first().text().trim()} collapsed`;
								},
							});
						}

						handleChange();

						$(summary).on('click', function () {
							setTimeout(() => {
								handleChange();
							}, 0);
						});
					});
			});
	});

	// $('.yotpo-reviews-container').each((i, container) => {
	// 	const list = $(container).find('.yotpo-reviews-list');

	// 	function handleChange() {
	// 		list.find('> .yotpo-review').each((i, review) => {
	// 			const title = $(review).find('.yotpo-review-title');

	// 			$(review)
	// 				.find('.yotpo-read-more')
	// 				.on('click', function () {
	// 					$(review).find('.yotpo-read-more-text').attr('tabindex', -1).focus();
	// 				})
	// 				.attr({
	// 					'aria-label': function () {
	// 						return `${$(this).text().trim()} (${title.text().trim()})`;
	// 					}
	// 				});
	// 		});
	// 	};

	// 	handleChange();

	// 	list.each((i, div) => {
	// 		const observer = new MutationObserver(() => {
	// 			handleChange();
	// 		});

	// 		observer.observe(div, { childList: true });
	// 	});

	// });

	$('.yotpo-reviews-widget-dropdown').each((i, dropdown) => {
		function handleChange() {
			$(dropdown)
				.find('.yotpo-selected-icon')
				.each((i, icon) => {
					if (!icon.querySelector('title')) {
						$(icon).prepend(`<title>selected</title>`);
					}
				});
		}

		handleChange();

		const observer = new MutationObserver(() => {
			handleChange();
		});

		observer.observe(dropdown, {
			attributes: true,
			attributeFilter: ['aria-expanded'],
		});
	});

	$('.sunny__cart').each((i, cart) => {
		const observer = new MutationObserver((mutations) => {
			if (cart.classList.contains('active')) {
				trapFocus(cart, focusableSelector);
			}
		});

		observer.observe(cart, {
			attributes: true,
			attributeFilter: ['class'],
		});
	});

	let activeQuickView = null;

	$('.sunny__quickview-button').each((i, button) => {
		$(button).on('click', (e) => {
			activeQuickView = button;

			$('.sunny__quickshop-close').on('click', () => {
				activeQuickView.focus();
			});
		});
	});

	let activeInspirationView = null;

	$(
		'.template-home-gym-inspiration .shopify-section-inspiration-gallery-grid article > a',
	).each((i, button) => {
		$(button).on('click', (e) => {
			activeInspirationView = button;

			$('.sunny__inspiration-close').on('click', () => {
				activeInspirationView.focus();
			});
		});
	});

	let activeStoryView = null;

	$('.a11y-hotspot-handle').each((i, button) => {
		$(button).on('click', (e) => {
			activeStoryView = button;

			$('.sunny__story-close').on('click', () => {
				activeStoryView.focus();
			});
		});
	});

	$('.product-essentials--left').each((i, essentials) => {
		const slider = essentials.querySelector('.product-gallery-slider');

		if (!slider) {
			return;
		}

		$(essentials)
			.find('.swiper-pagination')
			.each((i, pagination) => {
				$(pagination).attr('aria-label', 'Slider Pagination');

				$(pagination)
					.find('.swiper-pagination-bullet')
					.each((i, bullet) => {
						$(bullet).attr({
							role: 'button',
							tabindex: '0',
							'aria-label': `Go to slide ${i + 1}`,
						});

						$(bullet).on('keydown', triggerSelfClick);

						$(bullet).on('click', () => {
							slider.swiper.slideTo(i);
						});
					});
			});
	});

	$('.template-app-home h1').attr({
		role: 'heading',
		'aria-level': 2,
	});

	$('#careers-sunny-health-amp-fitness-create-the-ultimate-home-gym').each(
		(i, body) => {
			$(body)
				.find('#search-filters')
				.each((i, searchFilters) => {
					$(searchFilters).prepend(
						`<label class="search-job-label" for="search-job">Search</label>`,
					);
				});
		},
	);

	findElementWithinTime('.swym-wishlist-detail-header').then((el) => {
		$(el).removeAttr('role').removeAttr('aria-level');
	});

	$('body').each((i, body) => {
		function handleChange() {
			$('#navTrigger').each((i, navTrigger) => {
				navTrigger.querySelector('.sr-only')?.remove();

				if (
					document.body.getAttribute('data-active-modal-mobile') ===
					'modal--mobile-menu'
				) {
					$(navTrigger).attr({
						'aria-label': 'Close Menu',
					});
				} else {
					$(navTrigger).attr({
						'aria-label': 'Open Menu',
					});
				}
			});
		}

		handleChange();

		const observer = new MutationObserver((mutations) => {
			handleChange();
		});

		observer.observe(body, {
			attributes: true,
			attributeFilter: ['data-active-modal-mobile'],
		});
	});

	$('.sunny__thumb-button').each((i, button) => {
		const parent = $(button).parent();

		parent.each((i, parent) => {
			function handleChange() {
				if (parent.classList.contains('active')) {
					$(button).attr({
						'aria-current': true,
					});
				} else {
					$(button).removeAttr('aria-current');
				}
			}

			handleChange();

			const observer = new MutationObserver((mutations) => {
				handleChange();
			});

			observer.observe(parent, {
				attributes: true,
				attributeFilter: ['class'],
			});
		});
	});

	$('.left-arrow-slider, .right-arrow-slider').each((i, button) => {
		function handleChange() {
			if ($(button).attr('aria-disabled') === 'true') {
				$(button).attr({
					disabled: 'disabled',
				});
			} else {
				$(button).removeAttr('disabled');
			}
		}

		handleChange();

		const observer = new MutationObserver((mutations) => {
			handleChange();
		});

		observer.observe(button, {
			attributes: true,
			attributeFilter: ['aria-disabled'],
		});
	});

	$('#collectionFilters').each((i, filters) => {
		function handleChange() {
			if (filters.classList.contains('active')) {
				$(filters).parents().siblings().attr('aria-hidden', true);
				setTimeout(() => {
					$(filters).find(focusableSelector).first().focus();
				}, 500);
			} else {
				$(filters).parents().siblings().removeAttr('aria-hidden');
			}
		}

		const observer = new MutationObserver(() => {
			handleChange();
		});

		observer.observe(filters, {
			attributes: true,
			attributeFilter: ['class'],
		});
	});

	console.log('Load');
});

function renameElementTag(oldElementSelector, newTag) {
	var oldElement = $(oldElementSelector);

	if (oldElement.length > 0) {
		var newElement = $('<' + newTag + '></' + newTag + '>');

		newElement.html(oldElement.html());

		$.each(oldElement[0].attributes, function () {
			newElement.attr(this.name, this.value);
		});

		oldElement.replaceWith(newElement);
	}
}

function isDOMElementEmpty(element) {
	if (element === null || element === undefined) {
		return true;
	}

	var $element = $(element);

	if ($element.length === 0 || !$element.text().trim()) {
		return true;
	}

	return $element.is(':empty');
}

function toggleAriaChecked(el) {
	el.setAttribute(
		'aria-checked',
		el.getAttribute('aria-checked') === 'false' ? 'true' : 'false',
	);
}
function onReviewModal() {
	setTimeout(() => {
		$('#newReviewFormModal').find('.yotpo-close-icon.btn-close').focus();
		$('#newReviewFormModal').off('.a11y');
		$('#newReviewFormModal').on('keydown.a11y', function (event) {
			if (event.key == 'Tab') {
				if (event.shiftKey) {
					if (
						$('#newReviewFormModal')
							.find('a, button, [tabindex="0"]')
							.first()[0] == event.currentTarget
					) {
						$('#newReviewFormModal')
							.find('a, button, [tabindex="0"]')
							.last()
							.focus();
						event.preventDefault();
					}
				} else if (
					$('#newReviewFormModal')
						.find('a, button, [tabindex="0"]')
						.last()[0] == event.currentTarget
				) {
					$('#newReviewFormModal')
						.find('a, button, [tabindex="0"]')
						.first()
						.focus();
					event.preventDefault();
				}
			}
		});
	});
}

function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
function onElementAdded() {
    const setDom = document.querySelectorAll('.break-h2-collection-title');
    // Check if any elements were found
    if (setDom.length > 0) {
        const brkrowElement = document.querySelector('.brkrow');
        const searchBrkrow = brkrowElement.className.split(' ');
        const searchBrkrowIndex = searchBrkrow.indexOf('brkrow');
        const getGridConfigText = searchBrkrowIndex !== -1 ? searchBrkrow[searchBrkrowIndex + 1] : null;
        
        // Split and get the last element
        const lastElement = getGridConfigText ? getGridConfigText.split('-').pop() : null;

        // console.log('--------- lastElement', lastElement);
        // console.log('--------- setDom', setDom);

        // Apply styles to each selected DOM element
        setDom.forEach(element => {
          if(isMobile()){
            element.style.gridColumn = `span 2`;
          }else {
            element.style.gridColumn = `span ${lastElement}`;
          }
        });
    }
}

function mutationObserverCallback(mutationsList) {
	for (let mutation of mutationsList) {
		if (mutation.type === 'childList') {
			mutation.addedNodes.forEach((node) => {
				if ($(node).find('.yotpo-email-view[role]').length > 0) {
					$(node).find('.yotpo-email-view').removeAttr('role');
					$(node).find('.yotpo-email-view').removeAttr('aria-level');
				}
				if (
					node.nodeType === Node.ELEMENT_NODE &&
					$(node).attr('id') == 'newReviewFormModal'
				) {
					onReviewModal();
				}
				if (
					node.nodeType === Node.ELEMENT_NODE &&
					$(node).attr('class') == 'yotpo-form-complete'
				) {
					onReviewModal();
				}
			});

           // Check if the target elements have been added
            if (typeof Shopify !== 'undefined' && document.querySelector('.break-h2-collection-title')) {
              if(!Shopify.blogMenuTags) {
                document.querySelector('.break-h2-collection-title').remove()
                return
              }
                onElementAdded();
                // observer.disconnect(); // Stop observing once the element is found
                // break; // Exit the loop once we find our elements
            }
          
		}
	}
}
const observer = new MutationObserver(mutationObserverCallback);
observer.observe(document.body, { childList: true, subtree: true });

function handleVideoPlayer(event) {
	let video = $('#' + $(event.currentTarget).attr('data-video'))[0];
	if (video.paused) {
		video.play();
		$(event.currentTarget).attr('aria-pressed', false);
	} else {
		video.pause();
		$(event.currentTarget).attr('aria-pressed', true);
	}
}

async function findElementWithinTime(selector, maxTimeInSeconds) {
	return new Promise(async (resolve, reject) => {
		let attempts = 0;
		const maxAttempts = maxTimeInSeconds;

		const interval = setInterval(async () => {
			attempts++;
			if (attempts >= maxAttempts) {
				clearInterval(interval);
				reject(
					new Error(`Element not found within ${maxTimeInSeconds} seconds.`),
				);
			}

			const targetElement = document.querySelector(selector);
			if (targetElement) {
				clearInterval(interval);
				resolve(targetElement);
			}
		}, 1000);
	});
}

function randomId(length = 10) {
	const possibleCharacters =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	const possibleCharacterArray = Array.from(possibleCharacters);
	const resultArray = [];

	for (let i = 0; i < length; i++) {
		const randomIndex = Math.floor(
			Math.random() * possibleCharacterArray.length,
		);
		const randomCharacter = possibleCharacterArray[randomIndex];
		resultArray.push(randomCharacter);
	}

	return resultArray.join('');
}

function trapFocus(element, focusableSelector = 'input, button, a') {
	if (!element || typeof element !== 'object') {
		console.error('Invalid element provided.');
		return;
	}

	const focusableElements = Array.from(
		element.querySelectorAll(focusableSelector),
	);

	if (focusableElements.length === 0) {
		console.warn('No focusable elements found within the provided element.');
		return;
	}

	const firstFocusable = focusableElements[0];
	const lastFocusable = focusableElements[focusableElements.length - 1];

	firstFocusable.addEventListener('keydown', (e) => {
		if (e.key === 'Tab' && e.shiftKey) {
			e.preventDefault();
			lastFocusable.focus();
		}
	});

	lastFocusable.addEventListener('keydown', (e) => {
		if (e.key === 'Tab' && !e.shiftKey) {
			e.preventDefault();
			firstFocusable.focus();
		}
	});

	// Focus the first focusable element initially.
	firstFocusable.focus();
}

function triggerSelfClick(e) {
	if (e.key === 'Enter') {
		e.preventDefault();
		e.target.click();
	}
}
